// extracted by mini-css-extract-plugin
export default {"link":"header-link_link__8qFtW","link_active":"header-link_link_active__y3m8E"};